export default __webpack_public_path__ + "static/media/play-circle-fill.ffa7aedf.svg";